import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    Box,
    Card,
    Typography,
    Button,
    CircularProgress
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { motion } from "motion/react";
import apiSafibc from "../../axios/axios";

const MotionCard = motion(Card);

const ActivarUsuario = () => {
    const { codigo } = useParams();
    const navigate = useNavigate();

    const [estado, setEstado] = useState("cargando");

    useEffect(() => {
        const activarUsuario = async () => {
            try {

                await apiSafibc.put(`/blog/activar-usuario/${codigo}`)

                setEstado("exito");

            } catch (error) {
                console.error(error);
                setEstado("error");
            }
        };

        if (codigo) activarUsuario();
    }, [codigo]);

    return (
        <Box
            sx={{
                height: "65vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#eef5f9",
                px: 2
            }}
        >
            <MotionCard
                initial={{ opacity: 0, scale: 0.9, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ duration: 0.4 }}
                sx={{
                    p: 4,
                    maxWidth: 400,
                    width: "100%",
                    textAlign: "center",
                    borderRadius: 3,
                    boxShadow: 3
                }}
            >

                {/* CARGANDO */}
                {estado === "cargando" && (
                    <motion.div
                        key="loading"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                    >
                        <CircularProgress sx={{ mb: 2 }} />
                        <Typography variant="h6">
                            Activando tu cuenta...
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Esto solo tomará unos segundos
                        </Typography>
                    </motion.div>
                )}

                {/* ÉXITO */}
                {estado === "exito" && (
                    <motion.div
                        key="success"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.3 }}
                    >
                        <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ type: "spring", stiffness: 200 }}
                        >
                            <CheckCircleIcon color="success" sx={{ fontSize: 70, mb: 1 }} />
                        </motion.div>

                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                            ¡Cuenta activada!
                        </Typography>

                        <Typography variant="body1" color="text.secondary">
                            Ya puedes iniciar sesión sin problemas.
                        </Typography>

                        <Button
                            variant="contained"
                            fullWidth
                            sx={{ mt: 3 }}
                            onClick={() => navigate("/iniciar-sesion")}
                        >
                            Ir a iniciar sesión
                        </Button>
                    </motion.div>
                )}

                {/* ERROR */}
                {estado === "error" && (
                    <motion.div
                        key="error"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.3 }}
                    >
                        <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ type: "spring", stiffness: 200 }}
                        >
                            <ErrorIcon color="error" sx={{ fontSize: 70, mb: 1 }} />
                        </motion.div>

                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                            Ocurrió un error
                        </Typography>

                        <Typography variant="body1" color="text.secondary">
                            El código es inválido o ya expiró.
                        </Typography>

                        <Button
                            variant="contained"
                            color="error"
                            fullWidth
                            sx={{ mt: 3 }}
                            onClick={() => navigate("/iniciar-sesion")}
                        >
                            Ir a iniciar sesión
                        </Button>
                    </motion.div>
                )}

            </MotionCard>
        </Box>
    );
};

export default ActivarUsuario;